module.exports = __webpack_public_path__ + "img/certificado_digital.1bd7b77c.svg";